import { Map } from 'immutable'
import { Locale } from '../../drupal/types_and_parser/extra_types.mod'

export const allCountries = [
  'global',
  'Afghanistan',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium (Nederlands)',
  'Belgium (Francais)',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegowina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo, the Democratic Republic of the',
  'Cook Islands',
  'Costa Rica',
  "Cote d'Ivoire",
  'Croatia (Hrvatska)',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'East Timor',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (Malvinas)',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'France Metropolitan',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard and Mc Donald Islands',
  'Holy See (Vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran (Islamic Republic of)',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  "Korea, Democratic People's Republic of",
  'Korea, Republic of',
  'Kuwait',
  'Kyrgyzstan',
  "Lao, People's Democratic Republic",
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libyan Arab Jamahiriya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macau',
  'Macedonia, The Former Yugoslav Republic of',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova, Republic of',
  'Monaco',
  'Mongolia',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'Netherlands Antilles',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reunion',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia (Slovak Republic)',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'Spain',
  'Sri Lanka',
  'St. Helena',
  'St. Pierre and Miquelon',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen Islands',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan, Province of China',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'United States Minor Outlying Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela',
  'Vietnam',
  'Virgin Islands (British)',
  'Virgin Islands (U.S.)',
  'Wallis and Futuna Islands',
  'Western Sahara',
  'Yemen',
  'Yugoslavia',
  'Zambia',
  'Zimbabwe'
]

export const countriesLocale = Map<string, Locale>({
  'United Arab Emirates': 'ae',
  Australia: 'au',
  'Belgium (Nederlands)': 'be_nl',
  'Belgium (Francais)': 'be_fr',
  China: 'cn',
  Germany: 'de',
  Denmark: 'dk',
  Spain: 'es',
  France: 'fr',
  Finland: 'fi',
  'Hong Kong': 'hk',
  Ireland: 'ie',
  India: 'in',
  Italy: 'it',
  Mexico: 'mx',
  Argentina: 'mx',
  Bolivia: 'mx',
  Brazil: 'mx',
  Chile: 'mx',
  Colombia: 'mx',
  'Costa Rica': 'mx',
  Cuba: 'mx',
  'Dominican Republic': 'mx',
  Ecuador: 'mx',
  'El Salvador': 'mx',
  'French Guiana': 'mx',
  Guadeloupe: 'mx',
  Guatemala: 'mx',
  Haiti: 'mx',
  Honduras: 'mx',
  Martinique: 'mx',
  Nicaragua: 'mx',
  Panama: 'mx',
  Paraguay: 'mx',
  'Puerto Rico': 'mx',
  Uruguay: 'mx',
  Venezuala: 'mx',
  Malaysia: 'my',
  Netherlands: 'nl',
  Norway: 'no',
  'Russian Federation': 'ru',
  Sweden: 'se',
  'United Kingdom': 'uk',
  'North America': 'na',
  'United States': 'us',
  Poland: 'pl'
})

export const localeCountry = Map<Locale, string>({
  global: 'global',
  ae: 'United Arab Emirates',
  au: 'Australia',
  be_nl: 'Belgium (Nederlands)',
  be_fr: 'Belgium (Francais)',
  'na-fr': 'North America',
  'na-es': 'North America',
  cn: 'China',
  de: 'Germany',
  dk: 'Denmark',
  es: 'Spain',
  fr: 'France',
  hk: 'Hong Kong',
  ie: 'Ireland',
  in: 'India',
  it: 'Italy',
  fi: 'Finland',
  mx: 'global',
  my: 'Malaysia',
  nl: 'Netherlands',
  no: 'Norway',
  ru: 'Russian Federation',
  na: 'North America',
  se: 'Sweden',
  uk: 'United Kingdom',
  us: 'United States',
  pl: 'Poland'
})

export const refrescoAllCountries:string[] = [
  'North America',
  'UK',
  'Italy',
  'Iberia',
  'Germany',
  'France',
  'Finland',
  'Iberia',
  'Benelux',
  'Poland'
]

export const refrescoCountriesLocale = Map<string, Locale>({
  'North America':'us',
  'UK': 'uk',
  'Italy': 'it',
  'Iberia': ''
})
// refresco-drupal-ae      | postgres
// refresco-drupal-au      | postgres
// refresco-drupal-be      | postgres
// refresco-drupal-cn      | postgres
// refresco-drupal-de      | postgres
// refresco-drupal-dk      | postgres
// refresco-drupal-es      | postgres
// refresco-drupal-fr      | postgres
// refresco-drupal-hk      | postgres
// refresco-drupal-ie      | postgres
// refresco-drupal-in      | postgres
// refresco-drupal-it      | postgres
// refresco-drupal-mx      | postgres
// refresco-drupal-my      | postgres
// refresco-drupal-nl      | postgres
// refresco-drupal-no      | postgres
// refresco-drupal-ru      | postgres
// refresco-drupal-se      | postgres
// refresco-drupal-uk      | postgres
// refresco-drupal-us      | postgres